import { render, staticRenderFns } from "./HomeCustomer.vue?vue&type=template&id=7d1b1ef4&"
import script from "./HomeCustomer.vue?vue&type=script&lang=js&"
export * from "./HomeCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports